module.exports = __webpack_public_path__ + "static/media/041-download.e0ced7ab.svg";